<template>
    <div :style="{'direction': $vs.rtl ? 'rtl' : 'ltr'}">
      <feather-icon icon="Edit3Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" @click="editRecord" v-show="isEnabled"  />
      <feather-icon icon="Trash2Icon" svgClasses="h-5 w-5 mr-4 hover:text-danger cursor-pointer" @click="openDeleteConfirm" v-show="isEnabled" />
      <feather-icon icon="DownloadIcon" svgClasses="h-5 w-5 hover:text-danger cursor-pointer" @click="downloadModel" v-show="params.data.fileContent !== null" />
    </div>
</template>

<script>
export default {
  name: 'LomActionsCellRenderer',
  computed: {
    isEnabled() {
      return true;
    }
  },
  methods: {
    editRecord () {
      this.params.context.componentParent.editData(this.params.data);
    },

    openDeleteConfirm() {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: name,
        text: this.$t('CashFlow.Lom.ConfirmDelete'),
        accept: this.deleteRecord
      });
    },

    deleteRecord () {
      this.params.context.componentParent.deleteData(this.params.data.id);
    },

    downloadModel() {
      this.params.context.componentParent.downloadModel(this.params.data);
    }
  }
}
</script>
